/*
  ves-blog.js

  Load-more for the Editing blog grid. Fetches the next paginated page,
  appends its cards to the current list, and advances the button to the
  following page. history.replaceState keeps the URL on the deepest loaded
  page so the back button returns the reader to where they were, and the
  server-rendered ?page=N links stay crawlable underneath.
*/

(function () {
  'use strict';

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ves-blog-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var url = btn.getAttribute('href');

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.querySelector('[data-ves-blog-list]');
          var list = document.querySelector('[data-ves-blog-list]');
          if (newList && list) {
            while (newList.firstChild) list.appendChild(newList.firstChild);
          }
          var newBtn = doc.querySelector('[data-ves-blog-more]');
          if (newBtn) {
            btn.setAttribute('href', newBtn.getAttribute('href'));
            btn.classList.remove('is-loading');
          } else {
            var wrap = btn.closest('.ves-blog-grid__more');
            if (wrap) wrap.remove();
          }
          try {
            window.history.replaceState({}, '', url);
          } catch (err) { /* history is non-essential */ }
        })
        .catch(function () {
          // On any failure fall back to plain navigation; the href is a
          // real server-rendered page.
          window.location.href = url;
        });
    });
  }

  /* ---- Live article search ----
     Filters the rendered cards by title + excerpt text. On the first
     keystroke every remaining paginated page is fetched once so search
     covers the whole archive, mirroring the collection page mechanics. */
  function initSearch() {
    var input = document.querySelector('[data-ves-blog-search]');
    var list = document.querySelector('[data-ves-blog-list]');
    if (!input || !list) return;
    var clearBtn = document.querySelector('[data-ves-blog-search-clear]');
    var emptyEl = document.querySelector('[data-ves-blog-empty]');
    var emptyTerm = document.querySelector('[data-ves-blog-empty-term]');
    var loaded = false;
    var loading = null;

    function loadAllPagesOnce() {
      if (loaded || loading) return loading || Promise.resolve();
      var btn = document.querySelector('[data-ves-blog-more]');
      if (!btn) { loaded = true; return Promise.resolve(); }
      loading = (function fetchNext(url) {
        return fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newList = doc.querySelector('[data-ves-blog-list]');
            if (newList) {
              while (newList.firstChild) list.appendChild(newList.firstChild);
            }
            var nextBtn = doc.querySelector('[data-ves-blog-more]');
            if (nextBtn) return fetchNext(nextBtn.getAttribute('href'));
            loaded = true;
            var wrap = document.querySelector('.ves-blog-grid__more');
            if (wrap) wrap.remove();
          });
      })(btn.getAttribute('href'));
      return loading;
    }

    function applySearch() {
      var q = input.value.trim().toLowerCase();
      if (clearBtn) clearBtn.hidden = q === '';
      var featured = document.querySelector('.ves-blog-grid__featured');
      var moreWrap = document.querySelector('.ves-blog-grid__more');
      if (featured) featured.style.display = q ? 'none' : '';
      if (moreWrap) moreWrap.style.display = q ? 'none' : '';
      var hits = 0;
      list.querySelectorAll('.ves-blog-card').forEach(function (card) {
        if (!q) { card.style.display = ''; return; }
        if (card.classList.contains('ves-blog-promo')) { card.style.display = 'none'; return; }
        var text = (card.textContent || '').toLowerCase();
        var match = text.indexOf(q) !== -1;
        card.style.display = match ? '' : 'none';
        if (match) hits++;
      });
      if (emptyEl) {
        emptyEl.hidden = !(q && hits === 0);
        if (emptyTerm) emptyTerm.textContent = input.value.trim();
      }
    }

    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (input.value.trim()) {
          loadAllPagesOnce().then(applySearch);
        }
        applySearch();
      }, 160);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        applySearch();
        input.focus();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initSearch(); });
  } else {
    init();
    initSearch();
  }
})();
